import axios from 'axios';
import { DEFAULT_API_URL } from './shared/utils/constants';

const loginAxios = axios.create({
  baseURL: DEFAULT_API_URL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

export default loginAxios;
